import React from "react";

function Divider({ data }) {
  return (
    <div className="form-builder-element divider">
      <hr />
    </div>
  );
}

export default Divider;
